import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useContext
} from 'react';
import RecurringView from '../view/RecurringView';
import GeneralContext from '../../GeneralContext';

const parseDate = date => {
  let parsedDate = new Date(date);

  if (!(parsedDate instanceof Date && !isNaN(parsedDate))) {
    parsedDate = new Date(parseInt(date));
  }
  return parsedDate;
};

const getStopConditionDefaultValue = recurrenceBlock => {
  if (!recurrenceBlock) {
    return null;
  }

  if (recurrenceBlock.specificDate) {
    return 'specific';
  }
  if (recurrenceBlock.dateFieldName) {
    return 'field';
  }
  return 'other';
};

const getOptionsSet = (status, isDateFieldAvilable) => {
  let newSetOfOptions;
  switch (status) {
    // case 'incomplete':
    //   newSetOfOptions = ['complete', 'specific'];
    //   break;
    // case 'inbox':
    //   newSetOfOptions = ['registered', 'specific', 'field'];
    //   break;
    default:
      newSetOfOptions = ['specific', 'field', 'other'];
      break;
  }
  if (!isDateFieldAvilable) {
    newSetOfOptions = newSetOfOptions.filter(opt => opt !== 'field');
  }
  return newSetOfOptions;
};

const RecurringEngine = ({ reminderData, update }) => {
  const api = useContext(GeneralContext);
  const { allDateFields } = api;
  const defaultDate = new Date();
  defaultDate.setMonth(defaultDate.getMonth() + 1);

  const toggleRecurring = useCallback(() => {
    if (reminderData.recurrence) {
      update({ recurrence: undefined });
    } else {
      update({
        recurrence: {
          interval: 7,
          intervalUnit: 'day',
          specificDate: defaultDate + ''
        }
      });

      //also init hooks
      setIntervalCount(7);
      setSelectedDate(defaultDate + '');
      const options = getOptionsSet('', api.allDateFields.length);
      setStopConditions(options);
    }
  }, [reminderData]);
  const [intervalCount, setIntervalCount] = useState(
    reminderData.recurrence ? reminderData.recurrence.interval : null
  );
  const [stopConditions, setStopConditions] = useState(
    getOptionsSet('', api.allDateFields.length)
  );
  const [selectedDate, setSelectedDate] = useState(
    reminderData.recurrence && reminderData.recurrence.specificDate
      ? parseDate(reminderData.recurrence.specificDate)
      : defaultDate
  );

  const [selectedField, setSelectedField] = useState(
    (allDateFields.length && allDateFields[0].internalId) || ''
  );
  const [selectedStopCondition, setSelectedStopCondition] = useState(
    getStopConditionDefaultValue(reminderData.recurrence) || stopConditions[0]
  ); // stopCondition[0] - complete / registered

  const isFirstRender = useRef(true);
  useEffect(() => {
    const updateStopCondition = condition => {
      switch (condition) {
        case 'specific':
          update({
            'recurrence.dateFieldName': undefined,
            'recurrence.specificDate': (selectedDate instanceof Date
              ? selectedDate.getTime()
              : Date.parse(selectedDate)
            ).toString()
          });
          break;
        case 'field':
          update({
            'recurrence.specificDate': undefined,
            'recurrence.dateFieldName': selectedField
          });
          break;
        default:
          update({
            'recurrence.dateFieldName': undefined,
            'recurrence.specificDate': undefined
          });
          break;
      }
    };

    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      updateStopCondition(selectedStopCondition);
    }
  }, [selectedStopCondition, selectedDate, selectedField]);

  useEffect(() => {
    if (!reminderData.recurrence) {
      return;
    }

    const newConditions = getOptionsSet('', api.allDateFields.length);
    setStopConditions(newConditions);

    if (!newConditions.includes(selectedStopCondition)) {
      setSelectedStopCondition(newConditions[0]);
    }
  }, [reminderData.condition.statusList]);

  const viewProps = {
    reminderData,
    update,
    toggleRecurring,
    selectedDate,
    setSelectedDate,
    selectedField,
    setSelectedField,
    stopCondition: selectedStopCondition,
    setStopCondition: setSelectedStopCondition,
    statusOptions: stopConditions,
    intervalCount,
    setIntervalCount
  };

  return <RecurringView {...viewProps} />;
};

export default RecurringEngine;
